import type { KeyboardEvent } from "react";

export function handlePressedButtonGroupKey(
  event: KeyboardEvent<HTMLButtonElement>,
  values: string[],
  currentValue: string,
  select: (value: string) => void,
) {
  if (!["ArrowLeft", "ArrowRight", "Home", "End"].includes(event.key) || !values.length) return;
  event.preventDefault();
  const currentIndex = Math.max(0, values.indexOf(currentValue));
  const nextIndex = event.key === "Home"
    ? 0
    : event.key === "End"
      ? values.length - 1
      : event.key === "ArrowRight"
        ? (currentIndex + 1) % values.length
        : (currentIndex - 1 + values.length) % values.length;
  const buttons = event.currentTarget.parentElement?.querySelectorAll<HTMLButtonElement>("button[data-group-option]");
  buttons?.[nextIndex]?.focus();
  select(values[nextIndex]);
}
